import { ReactElement } from 'react';
import { IFragmentImageWithCopyFields } from 'types/contentful';

import Image from './Image';
import RichText from './Richtext';
import Link from 'next/link';

export const checkIsExternal = (slug: string | undefined): boolean => {
  if (slug) {
    return slug.startsWith('http') || slug.startsWith('tel:') || slug.startsWith('mailto:');
  }
  return false;
};

export default function ImageBlock({
  image,
  heading,
  copy,
  slug,
}: IFragmentImageWithCopyFields): ReactElement {
  let link = '';
  if (slug) {
    link = checkIsExternal(slug) ? slug : `/${slug.replace(/^\//, '')}`;
  }
  return (
    <div className="w-full lg:w-1/3 mb-5 lg:px-3">
      <div className="h-full overflow-hidden" style={{ backgroundColor: '#F7F7F7' }}>
        <div style={{ aspectRatio: '4 / 3' }}>
          {link ? (
            <a href={link}>
              <Image image={image} query="w=760" classNames="w-full h-full object-cover" />
            </a>
          ) : (
            <Image image={image} query="w=760" classNames="w-full h-full object-cover" />
          )}
        </div>
        <div className="px-6 py-6 lg:px-8 lg:py-8">
          {link && heading && (
            <a href={link}>
              <h3 className="text-xl lg:text-2xl leading-tight text-primary-actual">{heading}</h3>
            </a>
          )}
          {heading && !link && (
            <h3 className="text-xl lg:text-2xl leading-tight text-primary-actual">{heading}</h3>
          )}
          {copy && (
            <RichText
              document={copy}
              classNames="image-block-richtext mt-4 lg:mt-6 text-lg text-primary-actual"
            />
          )}
          {link && (
            <div className="mt-6 text-lg">
              <Link href={link}>
                <a className="inline-flex items-center text-secondary-actual font-heading">
                  <span>Learn More</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="16"
                    viewBox="0 0 10 16"
                    fill="none"
                    className="ml-3 flex-none"
                    aria-hidden="true"
                  >
                    <path
                      d="M1.5 14.5L8 8L1.5 1.5"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
